import React from 'react';

import classNames from 'classnames';
import { faPenToSquare, faVolume, faVolumeSlash, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';

import SparkBadge from '../spark_badge';
import { useConversationContext } from '../conversation_context';

interface Props {
  onClose?: () => void;
}

export default function AssistantHeader({ onClose }: Props) {
  const {
    busy, isAdmin, messages, speaking, startNewChat, toggleAdminDetails, toggleVoice, ttsSupported, voiceEnabled,
  } = useConversationContext();
  const newChatDisabled = busy || messages.length === 0;

  return (
    <Card.Header className="d-flex align-items-center gap-2">
      <SparkBadge onClick={isAdmin ? toggleAdminDetails : undefined} />
      <div className="flex-grow-1 lh-sm">
        <div className="fw-semibold">Otto</div>
        <div className="small text-muted">Your Buildout assistant</div>
      </div>
      {ttsSupported && (
        <Button
          aria-label={voiceEnabled ? 'Mute voice replies' : 'Unmute voice replies'}
          className={classNames({ 'text-primary': speaking && voiceEnabled })}
          icon={voiceEnabled ? faVolume : faVolumeSlash}
          size="sm"
          tooltip={voiceEnabled ? 'Mute voice replies' : 'Unmute voice replies'}
          variant="ghost"
          onClick={toggleVoice}
        />
      )}
      <Button
        aria-label="New chat"
        disabled={newChatDisabled}
        icon={faPenToSquare}
        size="sm"
        tooltip="New chat"
        variant="ghost"
        onClick={startNewChat}
      />
      {onClose && (
        <Button
          aria-label="Close"
          icon={faXmark}
          size="sm"
          variant="ghost"
          onClick={onClose}
        />
      )}
    </Card.Header>
  );
}
